import { Component, OnInit } from '@angular/core';
import { ToastComponent } from './toast.component';
import { Toast, ToasterService } from 'src/app/services/toaster.service';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';


@Component({
    selector: 'lib-toaster-container',
    templateUrl: './toast-container.component.html',
    standalone: true,
    imports: [ToastComponent, CommonModule]
})
export class ToasterContainerComponent implements OnInit {

    public toasts$!: Observable<Toast[]>;

    constructor(private toaster: ToasterService) { }

    ngOnInit(): void {
        this.toasts$ = this.toaster.bannerToast$;
    }

    public remove(toast: Toast): void {
        this.toaster.removeBanner(toast.id); // Remove the toast by id
    }
}